import { Box, Stack } from "@mui/material";
import { PaymentStatusViewModel } from "./PaymentStatusViewModel";
import { useLocation, useNavigate } from "react-router-dom";
import {
  COLOR_BLACK,
  COLOR_GREEN,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import {
  CheckBoxRounded,
  CheckRounded,
  CloseRounded,
} from "@mui/icons-material";
import { CustomTextView } from "../../component/CustomTextView";
import { useTranslation } from "react-i18next";
import { CustomButtonView } from "../../component/CustomButtonView";
import { ROUTE_ENDPOINTS } from "../../../data/constant/RouteConstants";
import { CustomCardView } from "../../component/CustomCardView";
import { LoadingView } from "../../component/LoadingView";
import {
  provideCreateTransactionUseCase,
  provideGetPaymentStatusUseCase,
  provideLoginByUIDUseCase,
  providePlayerGetCurrentInfoUseCase,
  provideRedeemDicountCodeUseCase,
  provideUpdatePlayerUseCase,
} from "../../di/UseCasesModule";

export function PaymentStatusView() {
  const { t } = useTranslation();
  const location = useLocation();
  const isSuccessful = location.pathname.includes("success");

  const viewModel = PaymentStatusViewModel(
    isSuccessful,
    provideGetPaymentStatusUseCase(),
    provideCreateTransactionUseCase(),
    provideRedeemDicountCodeUseCase(),
    providePlayerGetCurrentInfoUseCase(),
    provideUpdatePlayerUseCase(),
    provideLoginByUIDUseCase()
  );

  const navigate = useNavigate();
  return (
    <Stack
      width={"100vw"}
      height={"100vh"}
      sx={{ bgcolor: isSuccessful ? COLOR_GREEN : "red" }}
      alignItems={"center"}
      justifyContent={"center"}
      gap={10}
    >
      <Stack alignItems={"center"} gap={2}>
        <Stack
          sx={{ background: COLOR_WHITE, borderRadius: 30 }}
          width={60}
          height={60}
          alignItems={"center"}
          justifyContent={"center"}
        >
          {isSuccessful ? (
            <CheckRounded sx={{ color: COLOR_GREEN }} fontSize="large" />
          ) : (
            <CloseRounded sx={{ color: "red" }} fontSize="large" />
          )}
        </Stack>
        <CustomTextView
          text={t(
            isSuccessful
              ? "payment_was_successful"
              : "payment_was_not_successful"
          )}
          variant="h4"
          textColor={COLOR_WHITE}
          fontWeight="bold"
        />
      </Stack>

      {isSuccessful ? (
        <Stack width={"100%"} pl={"10%"} pr={"10%"}>
          <CustomCardView
            children={
              <Stack width={"100%"} alignItems={"center"} gap={2}>
                <CustomTextView
                  text={t("payment_details")}
                  variant="h5"
                  fontWeight="bold"
                />

                {viewModel.loading ? (
                  <LoadingView minHeight="20vh" />
                ) : (
                  <Stack width={"100%"} gap={1}>
                    <Stack
                      width={"100%"}
                      direction={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <CustomTextView
                        text={t("number_of_games")}
                        variant="body1"
                      />
                      <CustomTextView
                        text={viewModel.numberOfPurchasedGames?.toString()}
                        variant="h5"
                        fontWeight="bold"
                      />
                    </Stack>
                    <Stack
                      width={"100%"}
                      direction={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <CustomTextView
                        text={t("original_price_in_usd")}
                        variant="body1"
                      />
                      <CustomTextView
                        text={`$${viewModel.originalPriceInUSD}`}
                        variant="h5"
                        fontWeight="bold"
                      />
                    </Stack>
                    <Stack
                      width={"100%"}
                      direction={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <CustomTextView text={t("discount")} variant="body1" />
                      <CustomTextView
                        text={`${viewModel.discount}%`}
                        variant="h5"
                        fontWeight="bold"
                      />
                    </Stack>

                    <Stack width={"100%"} pt={2}>
                      <CustomButtonView
                        text={t("go_to_home_page")}
                        backgroundColor={COLOR_BLACK}
                        fontSize="h6"
                        props={{ p: 1 }}
                        onClick={() => {
                          navigate(ROUTE_ENDPOINTS.HOME_PLAY, {
                            replace: true,
                          });
                        }}
                      />
                    </Stack>
                  </Stack>
                )}
              </Stack>
            }
          />
        </Stack>
      ) : (
        <Stack width={"100%"} pl={"20%"} pr={"20%"}>
          <CustomButtonView
            text={t("go_to_home_page")}
            backgroundColor={COLOR_BLACK}
            fontSize="h5"
            props={{ p: 1 }}
            onClick={() => {
              navigate(ROUTE_ENDPOINTS.HOME_PLAY, { replace: true });
            }}
          />
        </Stack>
      )}
    </Stack>
  );
}
